/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ResetPasswordConfirmRouteImport } from './routes/reset-password-confirm'
import { Route as ResetPasswordFailureRouteImport } from './routes/reset-password-failure'
import { Route as ResetPasswordSuccessSetPasswordRouteImport } from './routes/reset-password-success-set-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpSuccessRouteImport } from './routes/sign-up-success'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as VerifyEmailConfirmRouteImport } from './routes/verify-email-confirm'
import { Route as VerifyEmailFailureRouteImport } from './routes/verify-email-failure'
import { Route as VerifyEmailSuccessRouteImport } from './routes/verify-email-success'
import { Route as VerifyEmailSuccessSetPasswordRouteImport } from './routes/verify-email-success-set-password'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedTeamIdRouteRouteImport } from './routes/_authed/$teamId/route'
import { Route as AuthedMeRouteImport } from './routes/_authed/me'
import { Route as AuthedTeamIdIndexRouteImport } from './routes/_authed/$teamId/index'
import { Route as AuthedTeamIdAdminRouteImport } from './routes/_authed/$teamId/admin'
import { Route as AuthedTeamIdPlaygroundRouteImport } from './routes/_authed/$teamId/playground'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed/admin/index'
import { Route as AuthedAdminLogsRouteImport } from './routes/_authed/admin/logs'
import { Route as AuthedAdminRumPageViewsRouteImport } from './routes/_authed/admin/rum-page-views'
import { Route as AuthedAdminRumSessionsRouteImport } from './routes/_authed/admin/rum-sessions'
import { Route as AuthedTeamIdReportTypesReportTypeIdRouteImport } from './routes/_authed/$teamId/report-types/$reportTypeId'
import { Route as AuthedTeamIdStudentGroupsIndexRouteImport } from './routes/_authed/$teamId/student-groups/index'
import { Route as AuthedTeamIdStudentGroupsStudentGroupIdRouteImport } from './routes/_authed/$teamId/student-groups/$studentGroupId'
import { Route as AuthedTeamIdStudentsIndexRouteImport } from './routes/_authed/$teamId/students/index'
import { Route as AuthedAdminCompletionsIndexRouteImport } from './routes/_authed/admin/completions/index'
import { Route as AuthedAdminCompletionsCompletionIdRouteImport } from './routes/_authed/admin/completions/$completionId'
import { Route as AuthedTeamIdStudentsStudentIdIndexRouteImport } from './routes/_authed/$teamId/students/$studentId/index'
import { Route as AuthedTeamIdStudentsStudentIdFilesFileIdRouteImport } from './routes/_authed/$teamId/students/$studentId/files/$fileId'
import { Route as AuthedTeamIdStudentsStudentIdGoalsIndexRouteImport } from './routes/_authed/$teamId/students/$studentId/goals/index'
import { Route as AuthedTeamIdStudentsStudentIdGoalsTrackRouteImport } from './routes/_authed/$teamId/students/$studentId/goals/track'
import { Route as AuthedTeamIdStudentsStudentIdReportsNewReportTypesRouteImport } from './routes/_authed/$teamId/students/$studentId/reports/new-report-types'
import { Route as AuthedTeamIdStudentsStudentIdGoalsGoalIdEditRouteImport } from './routes/_authed/$teamId/students/$studentId/goals/$goalId/edit'
import { Route as AuthedTeamIdStudentsStudentIdReportsReportIdIndexRouteImport } from './routes/_authed/$teamId/students/$studentId/reports/$reportId/index'
import { Route as AuthedTeamIdStudentsStudentIdReportsReportIdExportEditorRouteImport } from './routes/_authed/$teamId/students/$studentId/reports/$reportId/export-editor'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordConfirmRoute = ResetPasswordConfirmRouteImport.update({
  id: '/reset-password-confirm',
  path: '/reset-password-confirm',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordFailureRoute = ResetPasswordFailureRouteImport.update({
  id: '/reset-password-failure',
  path: '/reset-password-failure',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordSuccessSetPasswordRoute =
  ResetPasswordSuccessSetPasswordRouteImport.update({
    id: '/reset-password-success-set-password',
    path: '/reset-password-success-set-password',
    getParentRoute: () => rootRouteImport,
  } as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpSuccessRoute = SignUpSuccessRouteImport.update({
  id: '/sign-up-success',
  path: '/sign-up-success',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailConfirmRoute = VerifyEmailConfirmRouteImport.update({
  id: '/verify-email-confirm',
  path: '/verify-email-confirm',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailFailureRoute = VerifyEmailFailureRouteImport.update({
  id: '/verify-email-failure',
  path: '/verify-email-failure',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailSuccessRoute = VerifyEmailSuccessRouteImport.update({
  id: '/verify-email-success',
  path: '/verify-email-success',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailSuccessSetPasswordRoute =
  VerifyEmailSuccessSetPasswordRouteImport.update({
    id: '/verify-email-success-set-password',
    path: '/verify-email-success-set-password',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTeamIdRouteRoute = AuthedTeamIdRouteRouteImport.update({
  id: '/$teamId',
  path: '/$teamId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMeRoute = AuthedMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTeamIdIndexRoute = AuthedTeamIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedTeamIdRouteRoute,
} as any)
const AuthedTeamIdAdminRoute = AuthedTeamIdAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedTeamIdRouteRoute,
} as any)
const AuthedTeamIdPlaygroundRoute = AuthedTeamIdPlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => AuthedTeamIdRouteRoute,
} as any)
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminLogsRoute = AuthedAdminLogsRouteImport.update({
  id: '/admin/logs',
  path: '/admin/logs',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminRumPageViewsRoute = AuthedAdminRumPageViewsRouteImport.update({
  id: '/admin/rum-page-views',
  path: '/admin/rum-page-views',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminRumSessionsRoute = AuthedAdminRumSessionsRouteImport.update({
  id: '/admin/rum-sessions',
  path: '/admin/rum-sessions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTeamIdReportTypesReportTypeIdRoute =
  AuthedTeamIdReportTypesReportTypeIdRouteImport.update({
    id: '/report-types/$reportTypeId',
    path: '/report-types/$reportTypeId',
    getParentRoute: () => AuthedTeamIdRouteRoute,
  } as any)
const AuthedTeamIdStudentGroupsIndexRoute =
  AuthedTeamIdStudentGroupsIndexRouteImport.update({
    id: '/student-groups/',
    path: '/student-groups/',
    getParentRoute: () => AuthedTeamIdRouteRoute,
  } as any)
const AuthedTeamIdStudentGroupsStudentGroupIdRoute =
  AuthedTeamIdStudentGroupsStudentGroupIdRouteImport.update({
    id: '/student-groups/$studentGroupId',
    path: '/student-groups/$studentGroupId',
    getParentRoute: () => AuthedTeamIdRouteRoute,
  } as any)
const AuthedTeamIdStudentsIndexRoute =
  AuthedTeamIdStudentsIndexRouteImport.update({
    id: '/students/',
    path: '/students/',
    getParentRoute: () => AuthedTeamIdRouteRoute,
  } as any)
const AuthedAdminCompletionsIndexRoute =
  AuthedAdminCompletionsIndexRouteImport.update({
    id: '/admin/completions/',
    path: '/admin/completions/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAdminCompletionsCompletionIdRoute =
  AuthedAdminCompletionsCompletionIdRouteImport.update({
    id: '/admin/completions/$completionId',
    path: '/admin/completions/$completionId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedTeamIdStudentsStudentIdIndexRoute =
  AuthedTeamIdStudentsStudentIdIndexRouteImport.update({
    id: '/students/$studentId/',
    path: '/students/$studentId/',
    getParentRoute: () => AuthedTeamIdRouteRoute,
  } as any)
const AuthedTeamIdStudentsStudentIdFilesFileIdRoute =
  AuthedTeamIdStudentsStudentIdFilesFileIdRouteImport.update({
    id: '/students/$studentId/files/$fileId',
    path: '/students/$studentId/files/$fileId',
    getParentRoute: () => AuthedTeamIdRouteRoute,
  } as any)
const AuthedTeamIdStudentsStudentIdGoalsIndexRoute =
  AuthedTeamIdStudentsStudentIdGoalsIndexRouteImport.update({
    id: '/students/$studentId/goals/',
    path: '/students/$studentId/goals/',
    getParentRoute: () => AuthedTeamIdRouteRoute,
  } as any)
const AuthedTeamIdStudentsStudentIdGoalsTrackRoute =
  AuthedTeamIdStudentsStudentIdGoalsTrackRouteImport.update({
    id: '/students/$studentId/goals/track',
    path: '/students/$studentId/goals/track',
    getParentRoute: () => AuthedTeamIdRouteRoute,
  } as any)
const AuthedTeamIdStudentsStudentIdReportsNewReportTypesRoute =
  AuthedTeamIdStudentsStudentIdReportsNewReportTypesRouteImport.update({
    id: '/students/$studentId/reports/new-report-types',
    path: '/students/$studentId/reports/new-report-types',
    getParentRoute: () => AuthedTeamIdRouteRoute,
  } as any)
const AuthedTeamIdStudentsStudentIdGoalsGoalIdEditRoute =
  AuthedTeamIdStudentsStudentIdGoalsGoalIdEditRouteImport.update({
    id: '/students/$studentId/goals/$goalId/edit',
    path: '/students/$studentId/goals/$goalId/edit',
    getParentRoute: () => AuthedTeamIdRouteRoute,
  } as any)
const AuthedTeamIdStudentsStudentIdReportsReportIdIndexRoute =
  AuthedTeamIdStudentsStudentIdReportsReportIdIndexRouteImport.update({
    id: '/students/$studentId/reports/$reportId/',
    path: '/students/$studentId/reports/$reportId/',
    getParentRoute: () => AuthedTeamIdRouteRoute,
  } as any)
const AuthedTeamIdStudentsStudentIdReportsReportIdExportEditorRoute =
  AuthedTeamIdStudentsStudentIdReportsReportIdExportEditorRouteImport.update({
    id: '/students/$studentId/reports/$reportId/export-editor',
    path: '/students/$studentId/reports/$reportId/export-editor',
    getParentRoute: () => AuthedTeamIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/reset-password-confirm': typeof ResetPasswordConfirmRoute
  '/reset-password-failure': typeof ResetPasswordFailureRoute
  '/reset-password-success-set-password': typeof ResetPasswordSuccessSetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up-success': typeof SignUpSuccessRoute
  '/verify-email': typeof VerifyEmailRoute
  '/verify-email-confirm': typeof VerifyEmailConfirmRoute
  '/verify-email-failure': typeof VerifyEmailFailureRoute
  '/verify-email-success': typeof VerifyEmailSuccessRoute
  '/verify-email-success-set-password': typeof VerifyEmailSuccessSetPasswordRoute
  '/$teamId': typeof AuthedTeamIdRouteRouteWithChildren
  '/me': typeof AuthedMeRoute
  '/$teamId/admin': typeof AuthedTeamIdAdminRoute
  '/$teamId/playground': typeof AuthedTeamIdPlaygroundRoute
  '/admin/logs': typeof AuthedAdminLogsRoute
  '/admin/rum-page-views': typeof AuthedAdminRumPageViewsRoute
  '/admin/rum-sessions': typeof AuthedAdminRumSessionsRoute
  '/$teamId/': typeof AuthedTeamIdIndexRoute
  '/admin/': typeof AuthedAdminIndexRoute
  '/$teamId/report-types/$reportTypeId': typeof AuthedTeamIdReportTypesReportTypeIdRoute
  '/$teamId/student-groups/$studentGroupId': typeof AuthedTeamIdStudentGroupsStudentGroupIdRoute
  '/admin/completions/$completionId': typeof AuthedAdminCompletionsCompletionIdRoute
  '/$teamId/student-groups/': typeof AuthedTeamIdStudentGroupsIndexRoute
  '/$teamId/students/': typeof AuthedTeamIdStudentsIndexRoute
  '/admin/completions/': typeof AuthedAdminCompletionsIndexRoute
  '/$teamId/students/$studentId/': typeof AuthedTeamIdStudentsStudentIdIndexRoute
  '/$teamId/students/$studentId/files/$fileId': typeof AuthedTeamIdStudentsStudentIdFilesFileIdRoute
  '/$teamId/students/$studentId/goals/track': typeof AuthedTeamIdStudentsStudentIdGoalsTrackRoute
  '/$teamId/students/$studentId/reports/new-report-types': typeof AuthedTeamIdStudentsStudentIdReportsNewReportTypesRoute
  '/$teamId/students/$studentId/goals/': typeof AuthedTeamIdStudentsStudentIdGoalsIndexRoute
  '/$teamId/students/$studentId/goals/$goalId/edit': typeof AuthedTeamIdStudentsStudentIdGoalsGoalIdEditRoute
  '/$teamId/students/$studentId/reports/$reportId/export-editor': typeof AuthedTeamIdStudentsStudentIdReportsReportIdExportEditorRoute
  '/$teamId/students/$studentId/reports/$reportId/': typeof AuthedTeamIdStudentsStudentIdReportsReportIdIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/reset-password-confirm': typeof ResetPasswordConfirmRoute
  '/reset-password-failure': typeof ResetPasswordFailureRoute
  '/reset-password-success-set-password': typeof ResetPasswordSuccessSetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up-success': typeof SignUpSuccessRoute
  '/verify-email': typeof VerifyEmailRoute
  '/verify-email-confirm': typeof VerifyEmailConfirmRoute
  '/verify-email-failure': typeof VerifyEmailFailureRoute
  '/verify-email-success': typeof VerifyEmailSuccessRoute
  '/verify-email-success-set-password': typeof VerifyEmailSuccessSetPasswordRoute
  '/me': typeof AuthedMeRoute
  '/': typeof AuthedIndexRoute
  '/$teamId/admin': typeof AuthedTeamIdAdminRoute
  '/$teamId/playground': typeof AuthedTeamIdPlaygroundRoute
  '/admin/logs': typeof AuthedAdminLogsRoute
  '/admin/rum-page-views': typeof AuthedAdminRumPageViewsRoute
  '/admin/rum-sessions': typeof AuthedAdminRumSessionsRoute
  '/$teamId': typeof AuthedTeamIdIndexRoute
  '/admin': typeof AuthedAdminIndexRoute
  '/$teamId/report-types/$reportTypeId': typeof AuthedTeamIdReportTypesReportTypeIdRoute
  '/$teamId/student-groups/$studentGroupId': typeof AuthedTeamIdStudentGroupsStudentGroupIdRoute
  '/admin/completions/$completionId': typeof AuthedAdminCompletionsCompletionIdRoute
  '/$teamId/student-groups': typeof AuthedTeamIdStudentGroupsIndexRoute
  '/$teamId/students': typeof AuthedTeamIdStudentsIndexRoute
  '/admin/completions': typeof AuthedAdminCompletionsIndexRoute
  '/$teamId/students/$studentId': typeof AuthedTeamIdStudentsStudentIdIndexRoute
  '/$teamId/students/$studentId/files/$fileId': typeof AuthedTeamIdStudentsStudentIdFilesFileIdRoute
  '/$teamId/students/$studentId/goals/track': typeof AuthedTeamIdStudentsStudentIdGoalsTrackRoute
  '/$teamId/students/$studentId/reports/new-report-types': typeof AuthedTeamIdStudentsStudentIdReportsNewReportTypesRoute
  '/$teamId/students/$studentId/goals': typeof AuthedTeamIdStudentsStudentIdGoalsIndexRoute
  '/$teamId/students/$studentId/goals/$goalId/edit': typeof AuthedTeamIdStudentsStudentIdGoalsGoalIdEditRoute
  '/$teamId/students/$studentId/reports/$reportId/export-editor': typeof AuthedTeamIdStudentsStudentIdReportsReportIdExportEditorRoute
  '/$teamId/students/$studentId/reports/$reportId': typeof AuthedTeamIdStudentsStudentIdReportsReportIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/reset-password-confirm': typeof ResetPasswordConfirmRoute
  '/reset-password-failure': typeof ResetPasswordFailureRoute
  '/reset-password-success-set-password': typeof ResetPasswordSuccessSetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up-success': typeof SignUpSuccessRoute
  '/verify-email': typeof VerifyEmailRoute
  '/verify-email-confirm': typeof VerifyEmailConfirmRoute
  '/verify-email-failure': typeof VerifyEmailFailureRoute
  '/verify-email-success': typeof VerifyEmailSuccessRoute
  '/verify-email-success-set-password': typeof VerifyEmailSuccessSetPasswordRoute
  '/_authed/$teamId': typeof AuthedTeamIdRouteRouteWithChildren
  '/_authed/me': typeof AuthedMeRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/$teamId/admin': typeof AuthedTeamIdAdminRoute
  '/_authed/$teamId/playground': typeof AuthedTeamIdPlaygroundRoute
  '/_authed/admin/logs': typeof AuthedAdminLogsRoute
  '/_authed/admin/rum-page-views': typeof AuthedAdminRumPageViewsRoute
  '/_authed/admin/rum-sessions': typeof AuthedAdminRumSessionsRoute
  '/_authed/$teamId/': typeof AuthedTeamIdIndexRoute
  '/_authed/admin/': typeof AuthedAdminIndexRoute
  '/_authed/$teamId/report-types/$reportTypeId': typeof AuthedTeamIdReportTypesReportTypeIdRoute
  '/_authed/$teamId/student-groups/$studentGroupId': typeof AuthedTeamIdStudentGroupsStudentGroupIdRoute
  '/_authed/admin/completions/$completionId': typeof AuthedAdminCompletionsCompletionIdRoute
  '/_authed/$teamId/student-groups/': typeof AuthedTeamIdStudentGroupsIndexRoute
  '/_authed/$teamId/students/': typeof AuthedTeamIdStudentsIndexRoute
  '/_authed/admin/completions/': typeof AuthedAdminCompletionsIndexRoute
  '/_authed/$teamId/students/$studentId/': typeof AuthedTeamIdStudentsStudentIdIndexRoute
  '/_authed/$teamId/students/$studentId/files/$fileId': typeof AuthedTeamIdStudentsStudentIdFilesFileIdRoute
  '/_authed/$teamId/students/$studentId/goals/track': typeof AuthedTeamIdStudentsStudentIdGoalsTrackRoute
  '/_authed/$teamId/students/$studentId/reports/new-report-types': typeof AuthedTeamIdStudentsStudentIdReportsNewReportTypesRoute
  '/_authed/$teamId/students/$studentId/goals/': typeof AuthedTeamIdStudentsStudentIdGoalsIndexRoute
  '/_authed/$teamId/students/$studentId/goals/$goalId/edit': typeof AuthedTeamIdStudentsStudentIdGoalsGoalIdEditRoute
  '/_authed/$teamId/students/$studentId/reports/$reportId/export-editor': typeof AuthedTeamIdStudentsStudentIdReportsReportIdExportEditorRoute
  '/_authed/$teamId/students/$studentId/reports/$reportId/': typeof AuthedTeamIdStudentsStudentIdReportsReportIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/reset-password'
    | '/reset-password-confirm'
    | '/reset-password-failure'
    | '/reset-password-success-set-password'
    | '/sign-in'
    | '/sign-up-success'
    | '/verify-email'
    | '/verify-email-confirm'
    | '/verify-email-failure'
    | '/verify-email-success'
    | '/verify-email-success-set-password'
    | '/$teamId'
    | '/me'
    | '/$teamId/admin'
    | '/$teamId/playground'
    | '/admin/logs'
    | '/admin/rum-page-views'
    | '/admin/rum-sessions'
    | '/$teamId/'
    | '/admin/'
    | '/$teamId/report-types/$reportTypeId'
    | '/$teamId/student-groups/$studentGroupId'
    | '/admin/completions/$completionId'
    | '/$teamId/student-groups/'
    | '/$teamId/students/'
    | '/admin/completions/'
    | '/$teamId/students/$studentId/'
    | '/$teamId/students/$studentId/files/$fileId'
    | '/$teamId/students/$studentId/goals/track'
    | '/$teamId/students/$studentId/reports/new-report-types'
    | '/$teamId/students/$studentId/goals/'
    | '/$teamId/students/$studentId/goals/$goalId/edit'
    | '/$teamId/students/$studentId/reports/$reportId/export-editor'
    | '/$teamId/students/$studentId/reports/$reportId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/reset-password'
    | '/reset-password-confirm'
    | '/reset-password-failure'
    | '/reset-password-success-set-password'
    | '/sign-in'
    | '/sign-up-success'
    | '/verify-email'
    | '/verify-email-confirm'
    | '/verify-email-failure'
    | '/verify-email-success'
    | '/verify-email-success-set-password'
    | '/me'
    | '/'
    | '/$teamId/admin'
    | '/$teamId/playground'
    | '/admin/logs'
    | '/admin/rum-page-views'
    | '/admin/rum-sessions'
    | '/$teamId'
    | '/admin'
    | '/$teamId/report-types/$reportTypeId'
    | '/$teamId/student-groups/$studentGroupId'
    | '/admin/completions/$completionId'
    | '/$teamId/student-groups'
    | '/$teamId/students'
    | '/admin/completions'
    | '/$teamId/students/$studentId'
    | '/$teamId/students/$studentId/files/$fileId'
    | '/$teamId/students/$studentId/goals/track'
    | '/$teamId/students/$studentId/reports/new-report-types'
    | '/$teamId/students/$studentId/goals'
    | '/$teamId/students/$studentId/goals/$goalId/edit'
    | '/$teamId/students/$studentId/reports/$reportId/export-editor'
    | '/$teamId/students/$studentId/reports/$reportId'
  id:
    | '__root__'
    | '/_authed'
    | '/forgot-password'
    | '/reset-password'
    | '/reset-password-confirm'
    | '/reset-password-failure'
    | '/reset-password-success-set-password'
    | '/sign-in'
    | '/sign-up-success'
    | '/verify-email'
    | '/verify-email-confirm'
    | '/verify-email-failure'
    | '/verify-email-success'
    | '/verify-email-success-set-password'
    | '/_authed/$teamId'
    | '/_authed/me'
    | '/_authed/'
    | '/_authed/$teamId/admin'
    | '/_authed/$teamId/playground'
    | '/_authed/admin/logs'
    | '/_authed/admin/rum-page-views'
    | '/_authed/admin/rum-sessions'
    | '/_authed/$teamId/'
    | '/_authed/admin/'
    | '/_authed/$teamId/report-types/$reportTypeId'
    | '/_authed/$teamId/student-groups/$studentGroupId'
    | '/_authed/admin/completions/$completionId'
    | '/_authed/$teamId/student-groups/'
    | '/_authed/$teamId/students/'
    | '/_authed/admin/completions/'
    | '/_authed/$teamId/students/$studentId/'
    | '/_authed/$teamId/students/$studentId/files/$fileId'
    | '/_authed/$teamId/students/$studentId/goals/track'
    | '/_authed/$teamId/students/$studentId/reports/new-report-types'
    | '/_authed/$teamId/students/$studentId/goals/'
    | '/_authed/$teamId/students/$studentId/goals/$goalId/edit'
    | '/_authed/$teamId/students/$studentId/reports/$reportId/export-editor'
    | '/_authed/$teamId/students/$studentId/reports/$reportId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  ResetPasswordConfirmRoute: typeof ResetPasswordConfirmRoute
  ResetPasswordFailureRoute: typeof ResetPasswordFailureRoute
  ResetPasswordSuccessSetPasswordRoute: typeof ResetPasswordSuccessSetPasswordRoute
  SignInRoute: typeof SignInRoute
  SignUpSuccessRoute: typeof SignUpSuccessRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  VerifyEmailConfirmRoute: typeof VerifyEmailConfirmRoute
  VerifyEmailFailureRoute: typeof VerifyEmailFailureRoute
  VerifyEmailSuccessRoute: typeof VerifyEmailSuccessRoute
  VerifyEmailSuccessSetPasswordRoute: typeof VerifyEmailSuccessSetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password-confirm': {
      id: '/reset-password-confirm'
      path: '/reset-password-confirm'
      fullPath: '/reset-password-confirm'
      preLoaderRoute: typeof ResetPasswordConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password-failure': {
      id: '/reset-password-failure'
      path: '/reset-password-failure'
      fullPath: '/reset-password-failure'
      preLoaderRoute: typeof ResetPasswordFailureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password-success-set-password': {
      id: '/reset-password-success-set-password'
      path: '/reset-password-success-set-password'
      fullPath: '/reset-password-success-set-password'
      preLoaderRoute: typeof ResetPasswordSuccessSetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up-success': {
      id: '/sign-up-success'
      path: '/sign-up-success'
      fullPath: '/sign-up-success'
      preLoaderRoute: typeof SignUpSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email-confirm': {
      id: '/verify-email-confirm'
      path: '/verify-email-confirm'
      fullPath: '/verify-email-confirm'
      preLoaderRoute: typeof VerifyEmailConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email-failure': {
      id: '/verify-email-failure'
      path: '/verify-email-failure'
      fullPath: '/verify-email-failure'
      preLoaderRoute: typeof VerifyEmailFailureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email-success': {
      id: '/verify-email-success'
      path: '/verify-email-success'
      fullPath: '/verify-email-success'
      preLoaderRoute: typeof VerifyEmailSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email-success-set-password': {
      id: '/verify-email-success-set-password'
      path: '/verify-email-success-set-password'
      fullPath: '/verify-email-success-set-password'
      preLoaderRoute: typeof VerifyEmailSuccessSetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$teamId': {
      id: '/_authed/$teamId'
      path: '/$teamId'
      fullPath: '/$teamId'
      preLoaderRoute: typeof AuthedTeamIdRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/me': {
      id: '/_authed/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof AuthedMeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$teamId/': {
      id: '/_authed/$teamId/'
      path: '/'
      fullPath: '/$teamId/'
      preLoaderRoute: typeof AuthedTeamIdIndexRouteImport
      parentRoute: typeof AuthedTeamIdRouteRoute
    }
    '/_authed/$teamId/admin': {
      id: '/_authed/$teamId/admin'
      path: '/admin'
      fullPath: '/$teamId/admin'
      preLoaderRoute: typeof AuthedTeamIdAdminRouteImport
      parentRoute: typeof AuthedTeamIdRouteRoute
    }
    '/_authed/$teamId/playground': {
      id: '/_authed/$teamId/playground'
      path: '/playground'
      fullPath: '/$teamId/playground'
      preLoaderRoute: typeof AuthedTeamIdPlaygroundRouteImport
      parentRoute: typeof AuthedTeamIdRouteRoute
    }
    '/_authed/admin/': {
      id: '/_authed/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthedAdminIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/logs': {
      id: '/_authed/admin/logs'
      path: '/admin/logs'
      fullPath: '/admin/logs'
      preLoaderRoute: typeof AuthedAdminLogsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/rum-page-views': {
      id: '/_authed/admin/rum-page-views'
      path: '/admin/rum-page-views'
      fullPath: '/admin/rum-page-views'
      preLoaderRoute: typeof AuthedAdminRumPageViewsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/rum-sessions': {
      id: '/_authed/admin/rum-sessions'
      path: '/admin/rum-sessions'
      fullPath: '/admin/rum-sessions'
      preLoaderRoute: typeof AuthedAdminRumSessionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$teamId/report-types/$reportTypeId': {
      id: '/_authed/$teamId/report-types/$reportTypeId'
      path: '/report-types/$reportTypeId'
      fullPath: '/$teamId/report-types/$reportTypeId'
      preLoaderRoute: typeof AuthedTeamIdReportTypesReportTypeIdRouteImport
      parentRoute: typeof AuthedTeamIdRouteRoute
    }
    '/_authed/$teamId/student-groups/': {
      id: '/_authed/$teamId/student-groups/'
      path: '/student-groups'
      fullPath: '/$teamId/student-groups/'
      preLoaderRoute: typeof AuthedTeamIdStudentGroupsIndexRouteImport
      parentRoute: typeof AuthedTeamIdRouteRoute
    }
    '/_authed/$teamId/student-groups/$studentGroupId': {
      id: '/_authed/$teamId/student-groups/$studentGroupId'
      path: '/student-groups/$studentGroupId'
      fullPath: '/$teamId/student-groups/$studentGroupId'
      preLoaderRoute: typeof AuthedTeamIdStudentGroupsStudentGroupIdRouteImport
      parentRoute: typeof AuthedTeamIdRouteRoute
    }
    '/_authed/$teamId/students/': {
      id: '/_authed/$teamId/students/'
      path: '/students'
      fullPath: '/$teamId/students/'
      preLoaderRoute: typeof AuthedTeamIdStudentsIndexRouteImport
      parentRoute: typeof AuthedTeamIdRouteRoute
    }
    '/_authed/admin/completions/': {
      id: '/_authed/admin/completions/'
      path: '/admin/completions'
      fullPath: '/admin/completions/'
      preLoaderRoute: typeof AuthedAdminCompletionsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/completions/$completionId': {
      id: '/_authed/admin/completions/$completionId'
      path: '/admin/completions/$completionId'
      fullPath: '/admin/completions/$completionId'
      preLoaderRoute: typeof AuthedAdminCompletionsCompletionIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$teamId/students/$studentId/': {
      id: '/_authed/$teamId/students/$studentId/'
      path: '/students/$studentId'
      fullPath: '/$teamId/students/$studentId/'
      preLoaderRoute: typeof AuthedTeamIdStudentsStudentIdIndexRouteImport
      parentRoute: typeof AuthedTeamIdRouteRoute
    }
    '/_authed/$teamId/students/$studentId/files/$fileId': {
      id: '/_authed/$teamId/students/$studentId/files/$fileId'
      path: '/students/$studentId/files/$fileId'
      fullPath: '/$teamId/students/$studentId/files/$fileId'
      preLoaderRoute: typeof AuthedTeamIdStudentsStudentIdFilesFileIdRouteImport
      parentRoute: typeof AuthedTeamIdRouteRoute
    }
    '/_authed/$teamId/students/$studentId/goals/': {
      id: '/_authed/$teamId/students/$studentId/goals/'
      path: '/students/$studentId/goals'
      fullPath: '/$teamId/students/$studentId/goals/'
      preLoaderRoute: typeof AuthedTeamIdStudentsStudentIdGoalsIndexRouteImport
      parentRoute: typeof AuthedTeamIdRouteRoute
    }
    '/_authed/$teamId/students/$studentId/goals/track': {
      id: '/_authed/$teamId/students/$studentId/goals/track'
      path: '/students/$studentId/goals/track'
      fullPath: '/$teamId/students/$studentId/goals/track'
      preLoaderRoute: typeof AuthedTeamIdStudentsStudentIdGoalsTrackRouteImport
      parentRoute: typeof AuthedTeamIdRouteRoute
    }
    '/_authed/$teamId/students/$studentId/reports/new-report-types': {
      id: '/_authed/$teamId/students/$studentId/reports/new-report-types'
      path: '/students/$studentId/reports/new-report-types'
      fullPath: '/$teamId/students/$studentId/reports/new-report-types'
      preLoaderRoute: typeof AuthedTeamIdStudentsStudentIdReportsNewReportTypesRouteImport
      parentRoute: typeof AuthedTeamIdRouteRoute
    }
    '/_authed/$teamId/students/$studentId/goals/$goalId/edit': {
      id: '/_authed/$teamId/students/$studentId/goals/$goalId/edit'
      path: '/students/$studentId/goals/$goalId/edit'
      fullPath: '/$teamId/students/$studentId/goals/$goalId/edit'
      preLoaderRoute: typeof AuthedTeamIdStudentsStudentIdGoalsGoalIdEditRouteImport
      parentRoute: typeof AuthedTeamIdRouteRoute
    }
    '/_authed/$teamId/students/$studentId/reports/$reportId/': {
      id: '/_authed/$teamId/students/$studentId/reports/$reportId/'
      path: '/students/$studentId/reports/$reportId'
      fullPath: '/$teamId/students/$studentId/reports/$reportId/'
      preLoaderRoute: typeof AuthedTeamIdStudentsStudentIdReportsReportIdIndexRouteImport
      parentRoute: typeof AuthedTeamIdRouteRoute
    }
    '/_authed/$teamId/students/$studentId/reports/$reportId/export-editor': {
      id: '/_authed/$teamId/students/$studentId/reports/$reportId/export-editor'
      path: '/students/$studentId/reports/$reportId/export-editor'
      fullPath: '/$teamId/students/$studentId/reports/$reportId/export-editor'
      preLoaderRoute: typeof AuthedTeamIdStudentsStudentIdReportsReportIdExportEditorRouteImport
      parentRoute: typeof AuthedTeamIdRouteRoute
    }
  }
}

interface AuthedTeamIdRouteRouteChildren {
  AuthedTeamIdAdminRoute: typeof AuthedTeamIdAdminRoute
  AuthedTeamIdPlaygroundRoute: typeof AuthedTeamIdPlaygroundRoute
  AuthedTeamIdIndexRoute: typeof AuthedTeamIdIndexRoute
  AuthedTeamIdReportTypesReportTypeIdRoute: typeof AuthedTeamIdReportTypesReportTypeIdRoute
  AuthedTeamIdStudentGroupsStudentGroupIdRoute: typeof AuthedTeamIdStudentGroupsStudentGroupIdRoute
  AuthedTeamIdStudentGroupsIndexRoute: typeof AuthedTeamIdStudentGroupsIndexRoute
  AuthedTeamIdStudentsIndexRoute: typeof AuthedTeamIdStudentsIndexRoute
  AuthedTeamIdStudentsStudentIdIndexRoute: typeof AuthedTeamIdStudentsStudentIdIndexRoute
  AuthedTeamIdStudentsStudentIdFilesFileIdRoute: typeof AuthedTeamIdStudentsStudentIdFilesFileIdRoute
  AuthedTeamIdStudentsStudentIdGoalsTrackRoute: typeof AuthedTeamIdStudentsStudentIdGoalsTrackRoute
  AuthedTeamIdStudentsStudentIdReportsNewReportTypesRoute: typeof AuthedTeamIdStudentsStudentIdReportsNewReportTypesRoute
  AuthedTeamIdStudentsStudentIdGoalsIndexRoute: typeof AuthedTeamIdStudentsStudentIdGoalsIndexRoute
  AuthedTeamIdStudentsStudentIdGoalsGoalIdEditRoute: typeof AuthedTeamIdStudentsStudentIdGoalsGoalIdEditRoute
  AuthedTeamIdStudentsStudentIdReportsReportIdExportEditorRoute: typeof AuthedTeamIdStudentsStudentIdReportsReportIdExportEditorRoute
  AuthedTeamIdStudentsStudentIdReportsReportIdIndexRoute: typeof AuthedTeamIdStudentsStudentIdReportsReportIdIndexRoute
}

const AuthedTeamIdRouteRouteChildren: AuthedTeamIdRouteRouteChildren = {
  AuthedTeamIdAdminRoute: AuthedTeamIdAdminRoute,
  AuthedTeamIdPlaygroundRoute: AuthedTeamIdPlaygroundRoute,
  AuthedTeamIdIndexRoute: AuthedTeamIdIndexRoute,
  AuthedTeamIdReportTypesReportTypeIdRoute:
    AuthedTeamIdReportTypesReportTypeIdRoute,
  AuthedTeamIdStudentGroupsStudentGroupIdRoute:
    AuthedTeamIdStudentGroupsStudentGroupIdRoute,
  AuthedTeamIdStudentGroupsIndexRoute: AuthedTeamIdStudentGroupsIndexRoute,
  AuthedTeamIdStudentsIndexRoute: AuthedTeamIdStudentsIndexRoute,
  AuthedTeamIdStudentsStudentIdIndexRoute:
    AuthedTeamIdStudentsStudentIdIndexRoute,
  AuthedTeamIdStudentsStudentIdFilesFileIdRoute:
    AuthedTeamIdStudentsStudentIdFilesFileIdRoute,
  AuthedTeamIdStudentsStudentIdGoalsTrackRoute:
    AuthedTeamIdStudentsStudentIdGoalsTrackRoute,
  AuthedTeamIdStudentsStudentIdReportsNewReportTypesRoute:
    AuthedTeamIdStudentsStudentIdReportsNewReportTypesRoute,
  AuthedTeamIdStudentsStudentIdGoalsIndexRoute:
    AuthedTeamIdStudentsStudentIdGoalsIndexRoute,
  AuthedTeamIdStudentsStudentIdGoalsGoalIdEditRoute:
    AuthedTeamIdStudentsStudentIdGoalsGoalIdEditRoute,
  AuthedTeamIdStudentsStudentIdReportsReportIdExportEditorRoute:
    AuthedTeamIdStudentsStudentIdReportsReportIdExportEditorRoute,
  AuthedTeamIdStudentsStudentIdReportsReportIdIndexRoute:
    AuthedTeamIdStudentsStudentIdReportsReportIdIndexRoute,
}

const AuthedTeamIdRouteRouteWithChildren =
  AuthedTeamIdRouteRoute._addFileChildren(AuthedTeamIdRouteRouteChildren)

interface AuthedRouteChildren {
  AuthedTeamIdRouteRoute: typeof AuthedTeamIdRouteRouteWithChildren
  AuthedMeRoute: typeof AuthedMeRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedAdminLogsRoute: typeof AuthedAdminLogsRoute
  AuthedAdminRumPageViewsRoute: typeof AuthedAdminRumPageViewsRoute
  AuthedAdminRumSessionsRoute: typeof AuthedAdminRumSessionsRoute
  AuthedAdminIndexRoute: typeof AuthedAdminIndexRoute
  AuthedAdminCompletionsCompletionIdRoute: typeof AuthedAdminCompletionsCompletionIdRoute
  AuthedAdminCompletionsIndexRoute: typeof AuthedAdminCompletionsIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedTeamIdRouteRoute: AuthedTeamIdRouteRouteWithChildren,
  AuthedMeRoute: AuthedMeRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedAdminLogsRoute: AuthedAdminLogsRoute,
  AuthedAdminRumPageViewsRoute: AuthedAdminRumPageViewsRoute,
  AuthedAdminRumSessionsRoute: AuthedAdminRumSessionsRoute,
  AuthedAdminIndexRoute: AuthedAdminIndexRoute,
  AuthedAdminCompletionsCompletionIdRoute:
    AuthedAdminCompletionsCompletionIdRoute,
  AuthedAdminCompletionsIndexRoute: AuthedAdminCompletionsIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ResetPasswordConfirmRoute: ResetPasswordConfirmRoute,
  ResetPasswordFailureRoute: ResetPasswordFailureRoute,
  ResetPasswordSuccessSetPasswordRoute: ResetPasswordSuccessSetPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpSuccessRoute: SignUpSuccessRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  VerifyEmailConfirmRoute: VerifyEmailConfirmRoute,
  VerifyEmailFailureRoute: VerifyEmailFailureRoute,
  VerifyEmailSuccessRoute: VerifyEmailSuccessRoute,
  VerifyEmailSuccessSetPasswordRoute: VerifyEmailSuccessSetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
